import type { RouteRecordRaw } from 'vue-router';
import { IP_ROUTE_NAMES } from './ip-route-names';

export const ipRouterList: RouteRecordRaw[] = [
    {
        path: '/ip',
        redirect: '/ip/#/home',
        meta: { isIpModule: true },
    },
    {
        path: '/ip/legacy',
        name: IP_ROUTE_NAMES.IP_LEGACY,
        component: () => import('@/pages/home/IP.vue'),
    },
    {
        path: '/ip/pricing',
        name: IP_ROUTE_NAMES.IP_PRICING,
        component: () => import('@/pages/ip/IpPricing.vue'),
        meta: { isIpModule: true },
    }
]
